import { createReducer } from 'deox';
import produce from 'immer';
import {
  getCartsAction,
  getCartByIdAction,
  createCartAction,
  deleteCartAction,
  commitCartAction,
  addItemsAction,
  getCartItemAction,
  updateCartItemAction,
  deleteCartItemAction,
  searchSuppliersAction,
  getSuppliersAction,
} from './actions';
import { CartsState } from './types';

const initialState: CartsState = {
  isLoading: {
    list: false,
    single: false,
    create: false,
    delete: false,
    commit: false,
    addItems: false,
    updateItem: false,
    deleteItem: false,
    suppliers: false,
    serchDetailsBySuppliers: false,
  },
  errors: {
    list: null,
    single: null,
    create: null,
    delete: null,
    commit: null,
    addItems: null,
    updateItem: null,
    deleteItem: null,
    suppliers: null,
    serchDetailsBySuppliers: null,
  },
  list: null,
  currentCart: null,
  suppliers: null,
  serchDetailsBySuppliers: null,
};

export const cartsReducer = createReducer(initialState, handle => [
  // Получение списка корзин
  handle(getCartsAction.request, state =>
    produce(state, draft => {
      draft.isLoading.list = true;
      draft.errors.list = null;
    }),
  ),
  handle(getCartsAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = null;
      draft.list = payload;
    }),
  ),
  handle(getCartsAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = payload;
    }),
  ),

  // Получение одной корзины
  handle(getCartByIdAction.request, state =>
    produce(state, draft => {
      draft.isLoading.single = true;
      draft.errors.single = null;
    }),
  ),
  handle(getCartByIdAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = null;
      draft.currentCart = payload;
    }),
  ),
  handle(getCartByIdAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = payload;
    }),
  ),

  // Создание корзины
  handle(createCartAction.request, state =>
    produce(state, draft => {
      draft.isLoading.create = true;
      draft.errors.create = null;
    }),
  ),
  // handle(createCartAction.success, (state, { payload }) =>
  //   produce(state, draft => {
  //     draft.isLoading.create = false;
  //     draft.errors.create = null;
  //     if (draft.list) {
  //       draft.list.push(payload); // добавляем новую корзину в список
  //     } else {
  //       draft.list = [payload];
  //     }
  //   }),
  // ),
  handle(createCartAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.create = false;
      draft.errors.create = payload;
    }),
  ),

  // Удаление корзины
  // handle(deleteCartAction.request, state =>
  //   produce(state, draft => {
  //     draft.isLoading.delete = true;
  //     draft.errors.delete = null;
  //   }),
  // ),
  // handle(deleteCartAction.success, (state, { payload: id }) =>
  //   produce(state, draft => {
  //     draft.isLoading.delete = false;
  //     draft.errors.delete = null;
  //     if (draft.list) {
  //       draft.list = draft.list.filter(cart => cart.pk !== id);
  //     }
  //   }),
  // ),
  handle(deleteCartAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.delete = false;
      draft.errors.delete = payload;
    }),
  ),

  // Коммит корзины
  handle(commitCartAction.request, state =>
    produce(state, draft => {
      draft.isLoading.commit = true;
      draft.errors.commit = null;
    }),
  ),
  handle(commitCartAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.commit = false;
      draft.errors.commit = null;
      // обновляем текущую корзину, если был закоммичен
      draft.currentCart = payload;
    }),
  ),
  handle(commitCartAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.commit = false;
      draft.errors.commit = payload;
    }),
  ),

  // Добавление товаров в корзину
  handle(addItemsAction.request, state =>
    produce(state, draft => {
      draft.isLoading.addItems = true;
      draft.errors.addItems = null;
    }),
  ),
  handle(addItemsAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.addItems = false;
      draft.errors.addItems = null;
      // обновляем текущую корзину с новыми товарами
      draft.currentCart = payload;
    }),
  ),
  handle(addItemsAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.addItems = false;
      draft.errors.addItems = payload;
    }),
  ),

  // Получение товара по ID
  handle(getCartItemAction.request, state =>
    produce(state, draft => {
      draft.isLoading.single = true;
      draft.errors.single = null;
    }),
  ),
  handle(getCartItemAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = null;
      // обновляем текущий товар в текущей корзине
      if (draft.currentCart) {
        const itemIndex = draft.currentCart.order_items.findIndex(item => item.pk === payload.pk);
        if (itemIndex !== -1) {
          draft.currentCart.order_items[itemIndex] = payload;
        }
      }
    }),
  ),
  handle(getCartItemAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.single = false;
      draft.errors.single = payload;
    }),
  ),

  // Обновление товара в корзине
  handle(updateCartItemAction.request, state =>
    produce(state, draft => {
      draft.isLoading.updateItem = true;
      draft.errors.updateItem = null;
    }),
  ),
  handle(updateCartItemAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.updateItem = false;
      draft.errors.updateItem = null;
      if (draft.currentCart) {
        const itemIndex = draft.currentCart.order_items.findIndex(item => item.pk === payload.pk);
        if (itemIndex !== -1) {
          draft.currentCart.order_items[itemIndex] = payload;
        }
      }
    }),
  ),
  handle(updateCartItemAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.updateItem = false;
      draft.errors.updateItem = payload;
    }),
  ),

  // Удаление товара из корзины
  handle(deleteCartItemAction.request, state =>
    produce(state, draft => {
      draft.isLoading.deleteItem = true;
      draft.errors.deleteItem = null;
    }),
  ),
  handle(deleteCartItemAction.success, state =>
    produce(state, draft => {
      draft.isLoading.deleteItem = false;
      draft.errors.deleteItem = null;
    }),
  ),
  handle(deleteCartItemAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.deleteItem = false;
      draft.errors.deleteItem = payload;
    }),
  ),

  // Поиск из списка поставщиков
  handle(searchSuppliersAction.request, state =>
    produce(state, draft => {
      draft.isLoading.serchDetailsBySuppliers = true;
      draft.errors.serchDetailsBySuppliers = null;
      draft.serchDetailsBySuppliers = null;
    }),
  ),
  // Успешный запрос поставщиков
  handle(searchSuppliersAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.serchDetailsBySuppliers = false;
      draft.serchDetailsBySuppliers = payload;
    }),
  ),
  // Ошибка при запросе поставщиков
  handle(searchSuppliersAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.serchDetailsBySuppliers = false;
      draft.errors.serchDetailsBySuppliers = payload;
    }),
  ),
  // Начало загрузки списка поставщиков
  handle(getSuppliersAction.request, state =>
    produce(state, draft => {
      draft.isLoading.suppliers = true;
      draft.errors.suppliers = null;
    }),
  ),
  // Успешное получение списка поставщиков
  handle(getSuppliersAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.suppliers = false;
      draft.errors.suppliers = null;
      draft.suppliers = payload;
    }),
  ),
  // Ошибка при получении списка поставщиков
  handle(getSuppliersAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.suppliers = false;
      draft.errors.suppliers = payload;
    }),
  ),
]);
